import { red, pink, purple, indigo, blue, cyan, teal, green, lime, yellow, blueGrey } from '@mui/material/colors';
import {Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Legend} from 'chart.js'; 
import {Grid, CircularProgress} from '@mui/material';
import {useTranslation} from "react-i18next";
import React, {useState} from 'react';
import {Line} from "react-chartjs-2";
import {observer} from 'mobx-react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_OTHER, TAB_PROGRESS} from './StatsCommon.js';
import {monthNamesShort} from '../Trans.js';
import StatsFilter from './StatsFilter.js';
import {COMM_OK} from '../WsR2.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Legend);

const StatsProgress = observer((props) => {
	const [loading, setLoading] = useState(false);
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function progressListRxWs(status, msg) {
		setLoading(false);

		if (status !== COMM_OK) {
			alert('progressListRxWs: error ' + status);
			return;
		} 

		if (msg.result !== 'OK') {
			alert('progressListRxWs:' + msg.data.desc + '!');
			return;
		}

		if (gStorage.stats.tab !== TAB_OTHER || gStorage.stats.other_tab !== TAB_PROGRESS)
			return;

		// console.log('progressListRxWs', msg);
		gStorage.stats.setObsList(msg.data.progress);
	}

	function loadProgressList() {
		const curr_year = new Date().getFullYear();

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'year',
			op: 'progress',
			data: {
				country: gStorage.stats.country.id,
				user: gStorage.conn.user.id,
				first_year: curr_year - 100,
				last_year: curr_year,
			},
		};

// 		console.log('loadProgressList', msg);
		setLoading(true);
		gStorage.conn.ws.send(msg, progressListRxWs);		
	}

	if (gStorage.stats.tab !== TAB_OTHER || gStorage.stats.other_tab !== TAB_PROGRESS) 
		return null;

	if (!gStorage.stats.obsList && !loading) {
		if (gStorage.conn.online)
			loadProgressList();

		return null;
	}

	if (loading) {
		return (
			<Grid container direction="column" justifyContent="center" alignItems="center" spacing={0}>
				<CircularProgress sx={{mt: 10}} />
			</Grid>
		);
	}

	if (!gStorage.stats.obsList || !gStorage.stats.obsList.length)
		return null;

	const colors = [
		red[500],
		blue[500], 
		pink[500], 
		purple[500], 
		indigo[500], 
		cyan[500], 
		teal[500], 
		green[500], 
		lime[500], 
		yellow[500], 
		blueGrey[500],
	];

	let datasets = [], max_val = 0;

	gStorage.stats.obsList.forEach((e, ind) => {
		// console.log('year', e.year, e.progress);

		let dataset = {
			'label': e.year,
			'data': JSON.parse(JSON.stringify(e.progress)),
			'pointStyle': false,
			'cubicInterpolationMode': 'monotone',
			'tension': 0.4,
			'borderColor': colors[ind % colors.length],
			'borderWidth': 1,
		};

		datasets.push(dataset);

		if (e.progress[47] > max_val)
			max_val = e.progress[47];
		
	});

	max_val = Math.trunc(((max_val + 19) / 20)) * 20;

	return (
		<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
			<Grid size={{xs: 12}} align={'center'}>
				<StatsFilter 
					loc = {{country: {
							value: gStorage.stats.country,
							style: {width: 200}
						}
					}}
				/>
			</Grid>

			<Grid size={{xs: 12}} align={'center'}>
					<Line 
						data={{
							labels: new Array(48).fill(0),
							datasets: datasets,
						}}

						options = {{
							responsive: true,
							plugins: {
								legend: {
									display: true,
									position: 'top',
								},
								title: {
									display: false,
								}
							},
							scales: {
								y: {
									min: 0,
									max: max_val
								},
								x: {
									ticks: {
										callback: function(val, index) {
											if (index === 0) {
												return t(monthNamesShort[0]);
											} else if (index === 4) {
												return t(monthNamesShort[1]);
											} else if (index === 8) {
												return t(monthNamesShort[2])
											} else if (index === 12) {
												return t(monthNamesShort[3]);
											} else if (index === 16) {
												return t(monthNamesShort[4]);
											} else if (index === 20) {
												return t(monthNamesShort[5]);
											} else if (index === 24) {
												return t(monthNamesShort[6]);
											} else if (index === 28) {
												return t(monthNamesShort[7]);
											} else if (index === 32) {
												return t(monthNamesShort[8]);
											} else if (index === 36) {
												return t(monthNamesShort[9]);
											} else if (index === 40) {
												return t(monthNamesShort[10]);
											} else if (index === 44) {
												return t(monthNamesShort[11]);
											}

											return '';
										},
	 									autoSkip: false,
										maxRotation: 0,
										minRotation: 0
									}, 
								}
							},
						}}
					/>
			</Grid>
		</Grid>
	);

});

export default StatsProgress;
